import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import Dashboardheader from "../../directives/dashboardheader";
import toast, { Toaster } from "react-hot-toast";
import config from "../../config/config";
import axios from "axios";
import {
  getBoxInvestmentHistoryAction,
  getboxValueAction,
} from "../../Action/user.action";
import { IoIosInformationCircleOutline } from "react-icons/io";
import { Link, useLocation, useNavigate } from "react-router-dom";

const Nftbox = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const [nftBoxValue, setNftBoxValue] = useState(100);
  const [liveMntPrice, setLiveMNTPrice] = useState(0);
  const [dynamic_mnt, set_dynamic_mnt] = useState(0);
  const [nftHystory, setnftHystory] = useState([]);
  const [page, setPage] = useState(1);
  const [paginationStatus, setpaginationStatus] = useState(false);
  const [isCustomClicked, setIsCustomClicked] = useState(false);
  const [holdingPrice, setHoldingPrice] = useState("");
  const [holdingMessage, setHoldingMessage] = useState("");

  useEffect(() => {
    if (state && state.nftBoxValue) {
      setNftBoxValue(parseInt(state.nftBoxValue));
    }
  }, []);

  useEffect(() => {
    if (state && state.nftBoxValue) {
      setNftBoxValue(parseInt(state.nftBoxValue));
    }
  }, []);

  useEffect(() => {
    getLiveMntPrice();
    getboxValue();
    calculation_for_MNT();
  }, [nftBoxValue]);

  useEffect(() => {
    getBoxInvestmentHistory();
  }, [page]);

  const addNftValue = () => {
    setNftBoxValue((prev) => parseInt(prev || 0, 10) + 100);
  };
  const decrementNftValue = () => {
    setNftBoxValue((prev) => (prev > 100 ? prev - 100 : prev));
  };

  const handleChange = (e) => {
    const value = parseInt(e.target.value, 10);

    setNftBoxValue(isNaN(value) || value < 0 ? 0 : value);

    // if (nftBoxValue > 100) {
    //   setWidth(230);
    // } else if (nftBoxValue > 1000) {
    //   setWidth(350);
    // }
  };

  const [width, setWidth] = useState(155);

  const handleUpdateBoxValue = (value) => {
    calculation_for_MNT();
    setNftBoxValue(value);

    if (value === 500) {
      setWidth(200);
    } else if (value === 1000) {
      setWidth(200);
    } else if (value === 10000) {
      setWidth(230);
    }
  };

  console.log("width", width);

  const getLiveMntPrice = async () => {
    try {
      const res = await axios.get(config.liveMntPrice);
      setLiveMNTPrice(res.data.data[0].price);
    } catch (error) {
      console.log(error);
    }
  };

  // Cal For Dynamic MNT Price
  const calculation_for_MNT = () => {
    let totalMnt = liveMntPrice > 0 ? nftBoxValue / liveMntPrice : 0;
    set_dynamic_mnt(totalMnt);
  };

  const getBoxInvestmentHistory = async () => {
    try {
      const data = {
        page: page,
        limit: 10,
      };
      const res = await getBoxInvestmentHistoryAction(data);
      if (res.data.history.length == 0) {
        setpaginationStatus(true);
      }
      if (res.success) {
        setnftHystory((prevData) => [...prevData, ...res.data.history]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleProceed = () => {
    if (nftBoxValue <= 0) {
      toast.dismiss();
      toast.error("Please insert box value.");
      return;
    }
    setNftBoxValue(100 * Math.round(nftBoxValue / 100));
    // if (nftBoxValue % 100 !== 0) {
    //   toast.error("Amount must be a multiple of 100");
    //   return;
    // }
    navigate(
      `${config.baseUrl}nftboxpurchasedetails/${100 * Math.round(nftBoxValue / 100)
      }`
    );
  };

  const handleCustomClick = () => {
    setNftBoxValue("");
    setIsCustomClicked(true);
    setTimeout(() => {
      const inputField = document.getElementById("nftBoxInput");
      inputField.type = "text";
      inputField.focus();
      inputField.setSelectionRange(
        inputField.value.length,
        inputField.value.length
      );
      inputField.type = "number";
    }, 0);
  };

  const getboxValue = async () => {
    try {
      const res = await getboxValueAction();
      if (res.success) {
        setHoldingPrice(res.data.nft_box_value);
        setHoldingMessage(res.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <div className="position-relative">
        <div className="db1"></div>
        {/* <div className="db3"></div> */}
        <div className="db4"></div>
        <div className="db5"></div>
        <div className="db6"></div>
        <div className="db7"></div>
        <div className="db8"></div>
        <Dashboardheader />
        {/* <img src="assets/images/nftbg2.png" className="position-absolute w-100  " style={{ top: 0, opacity: 0.7, height: "40%", zIndex: "-1" }} alt="" />
        <img src="assets/images/nftbg1.png" className="position-absolute w-100" style={{ bottom: 0, height: "40%", }} alt="" /> */}
        <Container
          className="position-relative my-5 h-100 text-white d-flex flex-column justify-content-center align-items-center align-content-center"
          style={{ height: "100%" }}
        >
          <div className="position-relative py-4"></div>

          <div className="">
            <h4 className="text-center " style={{ fontWeight: 500 }}>
              Enter your Preferred Amount
            </h4>
            <div className="d-flex justify-content-center align-items-center gap-md-5">
              <div
                style={{ fontWeight: 800, fontSize: 60, cursor: "pointer" }}
                onClick={decrementNftValue}
              >
                -
              </div>

              <div
                style={{
                  position: "relative",
                  textAlign: "center",
                  display: "inline-block",
                }}
              >
                <span
                  style={{
                    position: "absolute",
                    left: "14px",
                    top: "50%",
                    transform: "translateY(-50%)",

                    color: "white",
                    fontWeight: 800,
                    fontSize: 60,
                  }}
                >
                  $
                </span>

                {/* Hidden span to measure text width */}
                <span
                  id="hidden-text"
                  style={{
                    position: "absolute",
                    visibility: "hidden",
                    whiteSpace: "nowrap",
                    fontWeight: 800,
                    fontSize: "60px",
                    paddingLeft: "60px",
                    width:"250px"
                  }}
                >
                  {nftBoxValue || "0"}
                </span>

                <input
                  id="nftBoxInput"
                  type="number"
                  placeholder="100"
                  className="nftbox-input"
                  value={nftBoxValue}
                  onChange={handleChange}
                  onWheel={(e) => e.target.blur()}
                  style={{
                    paddingLeft: "60px",
                    fontWeight: 800,
                    fontSize: "60px",
                    textAlign: "center",
                    width: `${document.getElementById("hidden-text")?.offsetWidth || 250
                      }px`,
                    // width: `${width}px`,
                    border: "none",
                    borderRadius: "8px",
                    backgroundColor: "transparent",
                    color: "white",
                    minWidth: "170px", // Prevent collapsing too much
                    maxWidth:"250px"
                  }}
                />
              </div>
              <div
                style={{ fontWeight: 800, fontSize: 60, cursor: "pointer" }}
                onClick={addNftValue}
              >
                +
              </div>
            </div>
            <p className="text-center">Add Amount in multiples x 100 </p>

            <br />
            <div>
              <p className="text-center">
                Select your preferred purchase NFT Amount
              </p>
            </div>
            <div className="d-flex justify-content-center align-items-center gap-3 flex-wrap">
              <button
                className="nftbox-addon"
                onClick={() => handleUpdateBoxValue(500)}
              >
                $500
              </button>
              <button
                className="nftbox-addon "
                onClick={() => handleUpdateBoxValue(1000)}
              >
                $1000
              </button>
              <button
                className="nftbox-addon"
                onClick={() => handleUpdateBoxValue(10000)}
              >
                $10000
              </button>
              <button
                className="nftbox-addon"
                onClick={() => {
                  handleCustomClick();
                  setWidth(155);
                }}
              >
                Custom
              </button>{" "}
              {/* Update onClick */}
            </div>
            <br />
            <br />
            <div
              className="w-100 d-flex flex-row justify-content-center gap-4"
              style={{ userSelect: "none" }}
            >
              <img src="assets/images/nftbox2.svg" className="org-nft-star" alt="" />
              <img
                className="glow-img img-fluid px-5"
                src="assets/images/nftbox1.svg"
                style={{ maxWidth: 314, width: "100%" }}
                alt=""
              />
              <img src="assets/images/nftbox2.svg" className="org-nft-star" alt="" />
            </div>
          </div>
          <br />
          <br />
          <div className="text-center">
            <h5
              style={{ fontWeight: 500, color: "#ffffff99" }}
              className="mb-1"
            >
              Current Holdings{" "}
            </h5>
            <h3 style={{ fontWeight: 700 }}>$ {holdingPrice}</h3>
            <p
              style={{ fontWeight: 400, color: "#ffffff99" }}
              className="mb-0 d-flex align-items-center justify-content-center gap-2"
            >
              {/* <span><IoIosInformationCircleOutline style={{ fill: "black", backgroundColor: "#42FBFF", borderRadius: 10 }} /></span> {holdingMessage} */}
            </p>
          </div>
          <br />
          <div className="w-100 d-flex justify-content-center">
            <button
              className="nftbox-submit"
              style={{ maxWidth: 300, width: "100%" }}
              onClick={handleProceed}
            >
              {" "}
              Proceed
            </button>
            {/* <button className='nftbox-submit' style={{maxWidth:300, width:"100%"}} onClick={handleBuyNFTBox}>Proceed</button> */}
          </div>
        </Container>
      </div>
    </>
  );
};

export default Nftbox;
